import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProductForm, {
  ProductFormFields,
} from '../../components/Product/ProductForm';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';

export default function ProductsEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [formFields, setFormFields] = useState<ProductFormFields>(
    null as unknown as ProductFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  async function getProduct() {
    if (organization && id) {
      const response = await api.get(
        `organizations/${organization.id}/products/${id}`
      );

      setFormFields({
        name: response.data.name,
        price: response.data.price,
      });
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: ProductFormFields) => {
    try {
      await api.put(`organizations/${organization.id}/products/${id}`, data);

      navigate('/products');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    getProduct();
  }, [organization, id]);

  return (
    <ProductForm
      isLoading={isLoading}
      title={`Editar Produto ${id}`}
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
